/* tslint:disable */
/* eslint-disable */
export enum AddAccountRequestAdditionalPaymentTypeEnum {
  None = 'None',
  Additional = 'Additional',
  Regular = 'Regular'
}
